import React from "react";
import Lobby from "../features/lobby/Lobby";

interface Props {}

export const LobbyIndex: React.FC<Props> = () => {
  return <Lobby />;
};
export default LobbyIndex;
